import React, { useState } from "react";
import {
	ProSidebar,
	Menu,
	MenuItem,
	SubMenu,
	SidebarHeader,
	SidebarContent,
} from "react-pro-sidebar";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaBars, FaTasks, FaUserCog } from "react-icons/fa";
import { Link } from "react-router-dom";
import { UserConsumer } from "../UserContext";
import Logo from "../images/toss_white_icon.png";
import { connect, useDispatch } from "react-redux";
import { SET_NAVBAR_ITEMS, SET_NAVBAR_TAB } from "./navbarRedux/types";
import ios from "../images/iosQR.png";
import android from "../images/Android.png";
import IOSLogo from "../images/iosLogo.svg";
import AndroidLogo from "../images/androidLogo.svg";
import { CloseButton, Modal } from "react-bootstrap";

const Aside = (props, { rtl, toggled }) => {
	const dispatch = useDispatch();
	const [collapsed, setCollapsed] = useState(false);
	const handleCollapsedChange = () => {
		if (collapsed) {
			setCollapsed(false);
		} else {
			setCollapsed(true);
		}
	};
	const departmentIds = ["3", "4", "5", "6", "9"]; // departmnts to which tickets can be assigned
	const devIds = [
		"312",
		"180",
		"51",
		"251",
		"319",
		"173",
		"801",
		"168",
		"393", //kanza
		"400",
		"137", //arif
	]; // developers to whom feedback list should be shown
	const itemReqDepartmentIds = ["3", "5", "9"]; // To which review Item Requisition should be shown// SSN,accounts,admin
	const [modalShow, setmodalShow] = useState(false);
	const [isAndroidQr, setIsAndoidQr] = useState(false);
	const [isIOSQr, setIsIOSQr] = useState(false);

	// Styles
	const headerStyles = {
		background: "#068587 0% 0% no-repeat padding-box",
		boxShadow: "0px 2px 3px #0000000D",
		opacity: "1",
		padding: "0px 24px",
		textTransform: "uppercase",
		fontWeight: "bold",
		fontSize: 14,
		letterSpacing: "1px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	};
	const dashboardStyle = {
		borderRadius: "2px",
		boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 3px",
		margin: "0px 7px 1px 5px",
		textTransform: "Uppercase",
		padding: "0px",
	};
	const dashboardActiveStyle = {
		background: "0% 0% no-repeat padding-box padding-box rgb(23, 152, 153)",
		boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 3px",
		borderRadius: "2px",
		opacity: "0.98",
		margin: "0px 7px 1px 5px",
		textTransform: "Uppercase",
		padding: "0px",
	};
	const tabActiveStyle = {
		background: "0% 0% no-repeat padding-box padding-box rgb(23, 152, 153)",
		boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 3px",
		borderRadius: "2px",
		opacity: "0.98",
		margin: "0px 7px 1px 5px",
	};
	const tabStyle = {
		borderRadius: "2px",
		opacity: "0.98",
		margin: "0px 7px 1px 5px",
	};
	const selectedMenuItemStyle = {
		background: "0% 0% no-repeat padding-box padding-box rgb(23, 152, 153)",
		opacity: "0.9",
		borderRadius: "10px",
		marginRight: "15px",
		marginBottom: "2px",
		marginTop: "2px",
		fontWeight: "normal !important",
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				return (
					<>
						<aside style={{ height: "100vh" }}>
							<ProSidebar
								rtl={rtl}
								collapsed={toggled === true ? "" : collapsed}
								toggled={toggled}
								onToggle={props.handleToggleSidebar}
							>
								<SidebarHeader>
									<div style={headerStyles}>
										<div className="d-flex align-items-center">
											<div
												className={`${
													collapsed === true
														? "d-none"
														: "mr-auto"
												} `}
											>
												<Link
													to={
														userDetails.designation.toString() ===
														"4"
															? "/CMDashboard"
															: userDetails.empRole.includes(
																	"2"
															  ) ||
															  userDetails.empRole.includes(
																	"3"
															  )
															? "/SpDashboard"
															: "/MyDashboard"
													}
												>
													<img
														src={Logo}
														style={{
															width: "33px",
														}}
														alt="ohSnap"
														onClick={() => {
															dispatch({
																type: SET_NAVBAR_TAB,
																payload:
																	"Dashboard",
															});
															dispatch({
																type: SET_NAVBAR_ITEMS,
																payload:
																	"MyDashboard",
															});
															sessionStorage.removeItem(
																"TopBarTab"
															);
															sessionStorage.removeItem(
																"TopBarItem"
															);
															sessionStorage.setItem(
																"NavbarTab",
																"Dashboard"
															);
															sessionStorage.setItem(
																"NavbarItem",
																"MyDashboard"
															);
														}}
													/>
												</Link>
											</div>
											<div
												className={`${
													collapsed === true
														? "mr-auto ml-1"
														: "ml-auto"
												} `}
												style={{ cursor: "pointer" }}
											>
												<FaBars
													className={
														toggled === true &&
														"d-none"
													}
													onClick={
														handleCollapsedChange
													}
												/>
											</div>
										</div>
									</div>
								</SidebarHeader>
								<SidebarContent>
									<Menu iconShape="circle" className="pb-0">
										<MenuItem
											icon={
												<span className="tossIcon tossIcon-dashboard"></span>
											}
											style={
												props.navbarTab === "Dashboard"
													? dashboardActiveStyle
													: dashboardStyle
											}
										>
											<Link
												to={
													userDetails.designation.toString() ===
													"4"
														? "/CMDashboard"
														: userDetails.empRole.includes(
																"2"
														  ) ||
														  userDetails.empRole.includes(
																"3"
														  )
														? "/SpDashboard"
														: "/MyDashboard"
												}
												onClick={() => {
													dispatch({
														type: SET_NAVBAR_TAB,
														payload: "Dashboard",
													});
													dispatch({
														type: SET_NAVBAR_ITEMS,
														payload: "MyDashboard",
													});
													sessionStorage.setItem(
														"NavbarTab",
														"Dashboard"
													);
													sessionStorage.setItem(
														"NavbarItem",
														"MyDashboard"
													);
													sessionStorage.removeItem(
														"TopBarTab"
													);
													sessionStorage.removeItem(
														"TopBarItem"
													);
													props.handleToggleSidebar(
														false
													);
												}}
											>
												Dashboard
											</Link>
										</MenuItem>

										{/*--------- General Tasks ------------*/}

										<SubMenu
											title="General Tasks"
											className="submenu"
											icon={
												<span className="tossIcon tossIcon-bugs" />
											}
											defaultOpen={true}
											style={
												props.navbarTab ===
												"GeneralTasks"
													? tabActiveStyle
													: tabStyle
											}
										>
											{!userDetails.isConsultant && (
												<>
													<MenuItem
														className="proMenuItemInner "
														icon={
															<i
																className="fa fa-calendar"
																style={{
																	fontWeight:
																		"50",
																}}
															></i>
														}
														style={
															props.navbarItem ===
															"LeavesView"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/ManageLeavesView"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"GeneralTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"LeavesView",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"GeneralTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"LeavesView"
																);
																sessionStorage.removeItem(
																	"MyLeavesFilter"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															My Leaves
														</Link>
													</MenuItem>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-clock"></span>
														}
														style={
															props.navbarItem ===
															"OffsiteHours"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/OffsiteWorkHours"
															onClick={() => {
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"GeneralTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"OffsiteHours"
																);
																sessionStorage.removeItem(
																	"MyOffsiteFilter"
																);
																props.handleToggleSidebar(
																	false
																);
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"GeneralTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"OffsiteHours",
																});
															}}
														>
															My Offsite Hours
														</Link>
													</MenuItem>

													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-clock" />
														}
														style={
															props.navbarItem ===
															"OfficeHours"
																? selectedMenuItemStyle
																: null
														}
													>
														{" "}
														<Link
															to="/MyOfficeHours"
															onClick={() => {
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"GeneralTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"OfficeHours"
																);
																props.handleToggleSidebar(
																	false
																);
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"GeneralTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"OfficeHours",
																});
															}}
														>
															My Office Hours
														</Link>
													</MenuItem>
													{!userDetails.empRole.includes(
														"4"
													) && (
														<>
															<MenuItem
																className="proMenuItemInner"
																icon={
																	<i className="fas fa-dollar-sign dollarCircle-icon"></i>
																}
																style={
																	props.navbarItem ===
																	"MyReimbursement"
																		? selectedMenuItemStyle
																		: null
																}
															>
																<Link
																	to="/MyReimbursement"
																	onClick={() => {
																		sessionStorage.removeItem(
																			"TopBarTab"
																		);
																		sessionStorage.removeItem(
																			"TopBarItem"
																		);
																		sessionStorage.setItem(
																			"NavbarTab",
																			"GeneralTasks"
																		);
																		sessionStorage.setItem(
																			"NavbarItem",
																			"MyReimbursement"
																		);
																		sessionStorage.removeItem(
																			"MyMonthlyReimbFilter"
																		);
																		sessionStorage.removeItem(
																			"MyGeneralReimbFilter"
																		);
																		props.handleToggleSidebar(
																			false
																		);
																		dispatch(
																			{
																				type: SET_NAVBAR_TAB,
																				payload:
																					"GeneralTasks",
																			}
																		);
																		dispatch(
																			{
																				type: SET_NAVBAR_ITEMS,
																				payload:
																					"MyReimbursement",
																			}
																		);
																	}}
																>
																	My
																	Reimbursements
																</Link>
															</MenuItem>
															<MenuItem
																className="proMenuItemInner"
																icon={
																	<span className="tossIcon tossIcon-request"></span>
																}
																style={
																	props.navbarItem ===
																	"ItemRequisition"
																		? selectedMenuItemStyle
																		: null
																}
															>
																<Link
																	to="/ItemRequisition"
																	onClick={() => {
																		sessionStorage.removeItem(
																			"TopBarTab"
																		);
																		sessionStorage.removeItem(
																			"TopBarItem"
																		);
																		sessionStorage.setItem(
																			"NavbarTab",
																			"GeneralTasks"
																		);
																		sessionStorage.setItem(
																			"NavbarItem",
																			"ItemRequisition"
																		);
																		sessionStorage.removeItem(
																			"MyItemRequisition"
																		);
																		props.handleToggleSidebar(
																			false
																		);
																		dispatch(
																			{
																				type: SET_NAVBAR_TAB,
																				payload:
																					"GeneralTasks",
																			}
																		);
																		dispatch(
																			{
																				type: SET_NAVBAR_ITEMS,
																				payload:
																					"ItemRequisition",
																			}
																		);
																	}}
																>
																	Item
																	Requisition
																</Link>
															</MenuItem>

															<MenuItem
																className="proMenuItemInner"
																icon={
																	<span className="tossIcon tossIcon-ticket" />
																}
																style={
																	props.navbarItem ===
																	"MyTickets"
																		? selectedMenuItemStyle
																		: null
																}
															>
																<Link
																	to="/MyTickets"
																	onClick={() => {
																		dispatch(
																			{
																				type: SET_NAVBAR_TAB,
																				payload:
																					"GeneralTasks",
																			}
																		);
																		dispatch(
																			{
																				type: SET_NAVBAR_ITEMS,
																				payload:
																					"MyTickets",
																			}
																		);
																		sessionStorage.removeItem(
																			"TopBarTab"
																		);
																		sessionStorage.removeItem(
																			"TopBarItem"
																		);
																		sessionStorage.setItem(
																			"NavbarTab",
																			"GeneralTasks"
																		);
																		sessionStorage.setItem(
																			"NavbarItem",
																			"MyTickets"
																		);
																		props.handleToggleSidebar(
																			false
																		);
																	}}
																>
																	My Tickets
																</Link>
															</MenuItem>

															{departmentIds.includes(
																userDetails.department.toString()
															) && (
																<MenuItem
																	className="proMenuItemInner"
																	icon={
																		<FaTasks />
																	}
																	style={
																		props.navbarItem ===
																		"ResourceTickets"
																			? selectedMenuItemStyle
																			: null
																	}
																>
																	<Link
																		to="/DepartmentTicketListing"
																		onClick={() => {
																			dispatch(
																				{
																					type: SET_NAVBAR_TAB,
																					payload:
																						"GeneralTasks",
																				}
																			);
																			dispatch(
																				{
																					type: SET_NAVBAR_ITEMS,
																					payload:
																						"ResourceTickets",
																				}
																			);
																			sessionStorage.removeItem(
																				"TopBarTab"
																			);
																			sessionStorage.removeItem(
																				"TopBarItem"
																			);
																			sessionStorage.setItem(
																				"NavbarTab",
																				"GeneralTasks"
																			);
																			sessionStorage.setItem(
																				"NavbarItem",
																				"ResourceTickets"
																			);
																			props.handleToggleSidebar(
																				false
																			);
																		}}
																	>
																		Resource
																		Tickets
																	</Link>
																</MenuItem>
															)}
														</>
													)}
												</>
											)}
											<MenuItem
												className="proMenuItemInner"
												icon={
													<span className="tossIcon tossIcon-manageTimesheet" />
												}
												style={
													props.navbarItem ===
													"WeeklyView"
														? selectedMenuItemStyle
														: null
												}
											>
												<Link
													to="/WeeklyView"
													onClick={() => {
														sessionStorage.removeItem(
															"TopBarTab"
														);
														sessionStorage.removeItem(
															"TopBarItem"
														);
														sessionStorage.setItem(
															"NavbarTab",
															"GeneralTasks"
														);
														sessionStorage.setItem(
															"NavbarItem",
															"WeeklyView"
														);
														props.handleToggleSidebar(
															false
														);
														dispatch({
															type: SET_NAVBAR_TAB,
															payload:
																"GeneralTasks",
														});
														dispatch({
															type: SET_NAVBAR_ITEMS,
															payload:
																"WeeklyView",
														});
													}}
												>
													My Timesheet
												</Link>
											</MenuItem>
											<MenuItem
												className="proMenuItemInner"
												icon={
													<span className="tossIcon tossIcon-manageTimesheet" />
												}
												style={
													props.navbarItem ===
													"MyTimeSheetStatus"
														? selectedMenuItemStyle
														: null
												}
											>
												<Link
													to="/MyTimeSheetStatus"
													onClick={() => {
														sessionStorage.removeItem(
															"TopBarTab"
														);
														sessionStorage.removeItem(
															"TopBarItem"
														);
														sessionStorage.setItem(
															"NavbarTab",
															"GeneralTasks"
														);
														sessionStorage.setItem(
															"NavbarItem",
															"MyTimeSheetStatus"
														);
														sessionStorage.removeItem(
															"MyTimesheetStatus"
														);
														props.handleToggleSidebar(
															false
														);
														dispatch({
															type: SET_NAVBAR_TAB,
															payload:
																"GeneralTasks",
														});
														dispatch({
															type: SET_NAVBAR_ITEMS,
															payload:
																"MyTimeSheetStatus",
														});
													}}
												>
													My Timesheets Status
												</Link>
											</MenuItem>
											<MenuItem
												className="proMenuItemInner"
												icon={
													<span className="tossIcon tossIcon-reportbug" />
												}
												style={
													props.navbarItem === "Bug"
														? selectedMenuItemStyle
														: null
												}
											>
												<Link
													to="/Bug"
													onClick={() => {
														sessionStorage.removeItem(
															"TopBarTab"
														);
														sessionStorage.removeItem(
															"TopBarItem"
														);
														sessionStorage.setItem(
															"NavbarTab",
															"GeneralTasks"
														);
														sessionStorage.setItem(
															"NavbarItem",
															"Bug"
														);
														props.handleToggleSidebar(
															false
														);
														dispatch({
															type: SET_NAVBAR_TAB,
															payload:
																"GeneralTasks",
														});
														dispatch({
															type: SET_NAVBAR_ITEMS,
															payload: "Bug",
														});
													}}
												>
													Report a Bug
												</Link>
											</MenuItem>
											{devIds.includes(
												userDetails.id.toString()
											) && (
												<MenuItem
													className="proMenuItemInner"
													icon={
														<span className="tossIcon tossIcon-bugproblem" />
													}
													style={
														props.navbarItem ===
														"ReportedBugs"
															? selectedMenuItemStyle
															: null
													}
												>
													<Link
														to="/ReportedBugs"
														onClick={() => {
															sessionStorage.removeItem(
																"TopBarTab"
															);
															sessionStorage.removeItem(
																"TopBarItem"
															);
															sessionStorage.setItem(
																"NavbarTab",
																"GeneralTasks"
															);
															sessionStorage.setItem(
																"NavbarItem",
																"ReportedBugs"
															);
															props.handleToggleSidebar(
																false
															);
															dispatch({
																type: SET_NAVBAR_TAB,
																payload:
																	"GeneralTasks",
															});
															dispatch({
																type: SET_NAVBAR_ITEMS,
																payload:
																	"ReportedBugs",
															});
														}}
													>
														View Reported Bugs
													</Link>
												</MenuItem>
											)}
											<MenuItem
												className="proMenuItemInner"
												icon={
													<i
														className="fa fa-calendar"
														style={{
															fontWeight: "100",
														}}
													></i>
												}
												style={
													props.navbarItem ===
													"CalendarHolidays"
														? selectedMenuItemStyle
														: null
												}
											>
												<Link
													to="/CalendarHolidays"
													onClick={() => {
														sessionStorage.removeItem(
															"TopBarTab"
														);
														sessionStorage.removeItem(
															"TopBarItem"
														);
														sessionStorage.setItem(
															"NavbarTab",
															"GeneralTasks"
														);
														sessionStorage.setItem(
															"NavbarItem",
															"CalendarHolidays"
														);
														props.handleToggleSidebar(
															false
														);
														dispatch({
															type: SET_NAVBAR_TAB,
															payload:
																"GeneralTasks",
														});
														dispatch({
															type: SET_NAVBAR_ITEMS,
															payload:
																"CalendarHolidays",
														});
													}}
												>
													Calendar Holidays
												</Link>
											</MenuItem>
											<OverlayTrigger
  key="tooltip"
  placement="right"
  overlay={<Tooltip id={`tooltip-right`}> Device Management System</Tooltip>}
>
											<MenuItem
												className="proMenuItemInner"
												icon={
													<i
														className="far fa-hdd"
														style={{
															fontWeight: "100",
														}}
													></i>
												}
												style={
													props.navbarItem === "DMS"
														? selectedMenuItemStyle
														: null
												}
											>
												<Link
													to={{
														pathname:
															"https://dms.teo-intl.com/",
													}}
													target="_blank"
													onClick={() => {
														sessionStorage.removeItem(
															"TopBarTab"
														);
														sessionStorage.removeItem(
															"TopBarItem"
														);
														sessionStorage.setItem(
															"NavbarTab",
															"GeneralTasks"
														);
														sessionStorage.setItem(
															"NavbarItem",
															"DMS"
														);
														props.handleToggleSidebar(
															false
														);
														dispatch({
															type: SET_NAVBAR_TAB,
															payload:
																"GeneralTasks",
														});
														dispatch({
															type: SET_NAVBAR_ITEMS,
															payload: "DMS",
														});
													}}
												>
													Device Management System
												</Link>
											</MenuItem>
											</OverlayTrigger>
											{userDetails.empRole.includes(
												"4"
											) && ( //super admin
												<>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-clock" />
														}
														style={
															props.navbarItem ===
															"adminRole/AddEmployee"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/adminRole/AddEmployee"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"AdminTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"adminRole/AddEmployee",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"AdminTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"adminRole/AddEmployee"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Add Employee
														</Link>
													</MenuItem>
													<OverlayTrigger
  key="tooltip"
  placement="right"
  overlay={<Tooltip id={`tooltip-right`}> View Leaves
  Applications</Tooltip>}
>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-clock" />
														}
														style={
															props.navbarItem ===
															"adminRole/ViewLeaves"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/adminRole/ViewLeaves"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"AdminTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"adminRole/ViewLeaves",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"AdminTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"adminRole/ViewLeaves"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															View Leaves
															Applications
														</Link>
													</MenuItem>
													</OverlayTrigger>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-dollar" />
														}
													>
														<Link
															to="/ViewEmployees"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"ViewEmployees",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.removeItem(
																	"ViewEmployees"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"ViewEmployees"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															View Employees
														</Link>
													</MenuItem>
												</>
											)}
										</SubMenu>
										{/*--------- End of General Tasks ------------*/}

										{/*--------- Supervisor Tasks ------------*/}
										{userDetails.designation.toString() ===
											"4" ||
										userDetails.empRole.includes("2") ||
										userDetails.empRole.includes("5") ||
										userDetails.empRole.includes("3") ? (
											<SubMenu
												title="Supervisor Tasks"
												className="submenu"
												icon={
													<span className="tossIcon tossIcon-team" />
												}
												defaultOpen={
													sessionStorage.getItem(
														"NavbarTab"
													) === "SupervisorTasks"
												}
												style={
													props.navbarTab ===
													"SupervisorTasks"
														? tabActiveStyle
														: tabStyle
												}
											>
												<>
													{}
													<MenuItem
														className="proMenuItemInner"
														icon={
															<i className="tossIcon tossIcon-manageTimesheet"></i>
														}
														style={
															props.navbarItem ===
															"SpTimesheet"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/SpTimesheet"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"SpTimesheet",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"SpTimesheet"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Employee Timesheet
														</Link>
													</MenuItem>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-manageTimesheet" />
														}
														style={
															props.navbarItem ===
															"SpTimeSheetStatus"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/SpTimeSheetStatus"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"SpTimeSheetStatus",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"SpTimeSheetStatus"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Timesheet Status
														</Link>
													</MenuItem>
													<OverlayTrigger
  key="tooltip"
  placement="right"
  overlay={<Tooltip id={`tooltip-right`}> Timesheet
  Performance Report</Tooltip>}>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-report" />
														}
														style={
															props.navbarItem ===
															"TimesheetPerformanceReport"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="TimesheetPerformanceReport"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"TimesheetPerformanceReport",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"TimesheetPerformanceReport"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Timesheet
															Performance Report
														</Link>
													</MenuItem>
</OverlayTrigger>
													<OverlayTrigger
  key="tooltip"
  placement="right"
  overlay={<Tooltip id={`tooltip-right`}> Review Leave
  Application</Tooltip>}
>	
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-leave" />
														}
														style={
															props.navbarItem ===
															"SpReviewLeave"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/SpReviewLeave"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"SpReviewLeave",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"SpReviewLeave"
																);
																sessionStorage.removeItem(
																	"ReviewLeaveApplication"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Review Leave
															Application
														</Link>
													</MenuItem></OverlayTrigger>

													<OverlayTrigger
  key="tooltip"
  placement="right"
  overlay={<Tooltip id={`tooltip-right`}> 	Reviewed Leave
  Application</Tooltip>}
>	

													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-leave" />
														}
														style={
															props.navbarItem ===
															"SpReviewedLeave"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/SpReviewedLeave"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"SpReviewedLeave",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.removeItem(
																	"ReviewedLeaveApplication"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"SpReviewedLeave"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Reviewed Leave
															Application
														</Link>
													</MenuItem>

													</OverlayTrigger>
													{itemReqDepartmentIds.includes(
														userDetails.department.toString()
													) ||
													userDetails.empRole.includes(
														"2"
													) ||
													userDetails.designation.toString() ===
														"4" ||
													userDetails.designation.toString() ===
														"5" ? (
															<OverlayTrigger
															key="tooltip"
															placement="right"
															overlay={<Tooltip id={`tooltip-right`}> 	Review Item
															Requisition</Tooltip>}
														  >	
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-request"></span>
															}
															style={
																props.navbarItem ===
																"ReviewItemRequsition"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/ReviewItemRequsition"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"SpTimeSheetStatus",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ReviewItemRequsition",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"SupervisorTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ReviewItemRequsition"
																	);
																	sessionStorage.removeItem(
																		"ReviewItemRequsition"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Review Item
																Requisition
															</Link>
														</MenuItem>
														</OverlayTrigger>
													) : null}
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-clock"></span>
														}
														style={
															props.navbarItem ===
															"spOffsiteWorkHours"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/spOffsiteWorkHours"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"spOffsiteWorkHours",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"spOffsiteWorkHours"
																);
																sessionStorage.removeItem(
																	"SpOffsiteWorkHours"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Offsite Work
															Requests
														</Link>
													</MenuItem>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-extract" />
														}
														style={
															props.navbarItem ===
															"CheckInCheckOut"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/CheckInCheckOut"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"CheckInCheckOut",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"CheckInCheckOut"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Extract Checkin
															Checkout
														</Link>
													</MenuItem>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-calendar" />
														}
														style={
															props.navbarItem ===
															"SpMonthlyTimesheet"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/SpMonthlyTimesheet"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"SpMonthlyTimesheet",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"SpMonthlyTimesheet"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Monthly Timesheets
														</Link>
													</MenuItem>
													{userDetails.empRole.includes(
														"3"
													) ? (
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-info" />
															}
															style={
																props.navbarItem ===
																"ResourceLeavesInfo"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to={
																	"/ResourceLeavesInfo"
																}
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"SupervisorTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ResourceLeavesInfo",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"SupervisorTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ResourceLeavesInfo"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Employees Leaves
																Info
															</Link>
														</MenuItem>
													) : (
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-info" />
															}
															style={
																props.navbarItem ===
																"ResourceLeavesInfo"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to={
																	"/EmployeeLeavesListing"
																}
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"SupervisorTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ResourceLeavesInfo",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"SupervisorTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ResourceLeavesInfo"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Employees Leaves
																Info
															</Link>
														</MenuItem>
													)}
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-info" />
														}
														style={
															props.navbarItem ===
															"EmployeesMonthlyLeaves"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to={
																"/EmployeesMonthlyLeaves"
															}
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"EmployeesMonthlyLeaves",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"EmployeesMonthlyLeaves"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Employees Monthly
															Leaves
														</Link>
													</MenuItem>

													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-report" />
														}
														style={
															props.navbarItem ===
															"totalProjectHours"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="totalProjectHours"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"totalProjectHours",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"totalProjectHours"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Total Project Hours
														</Link>
													</MenuItem>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-report" />
														}
														style={
															props.navbarItem ===
															"ResourceProjectHours"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/ResourceProjectHours"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"ResourceProjectHours",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"ResourceProjectHours"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Resource Project
															Hours
														</Link>
													</MenuItem>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-report" />
														}
														style={
															props.navbarItem ===
															"resourceDailyHours"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/resourceDailyHours"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"resourceDailyHours",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"resourceDailyHours"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Resource Daily Hours
														</Link>
													</MenuItem>
													{
													userDetails.designation.toString() ===
														"4" ||
													userDetails.empRole.includes(
														"2"
													) ||
													userDetails.empRole.includes(
														"5"
													) ||
													userDetails.empRole.includes(
														"3"
													) ||
													userDetails.designation.toString() ===
														"7" ||
													userDetails.empRole.includes(
														"4"
													) ||
													userDetails.department.toString() ===
														"4" ? (
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-report" />
															}
															style={
																props.navbarItem ===
																"ProjectReport"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/ProjectReport"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"SupervisorTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ProjectReport",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"SupervisorTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ProjectReport"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Project Report
															</Link>
														</MenuItem>
													) : null}
												</>
												{
												
												userDetails.department.toString() ===
													"4" ||
												userDetails.department.toString() ===
												"5" ||
												userDetails.department.toString() ===
												"9" ||
												userDetails.department.toString() ===
												"3" ||
												userDetails.id.toString() ===
													"180"||
													userDetails.id.toString() ===
													"51"||
													userDetails.id.toString() ===
														"315"  ||
												userDetails.id.toString() ===
													"312" ? (
													<>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-projects" />
															}
															style={
																props.navbarItem ===
																"ProjectListing"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/ProjectListing"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"SupervisorTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ProjectListing",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"SupervisorTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ProjectListing"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																TEO Projects
															</Link>
														</MenuItem>

														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-dollar" />
															}
															style={
																props.navbarItem ===
																"ViewEmployees"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/ViewEmployees"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"SupervisorTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ViewEmployees",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.removeItem(
																		"ViewEmployees"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"SupervisorTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ViewEmployees"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																View Employees
															</Link>
														</MenuItem>
													</>
												) : null}
												{userDetails.designation.toString() ===
													"4" && (
													<>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-viewticket" />
															}
															style={
																props.navbarItem ===
																"CountryManagerTicketListing"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/CountryManagerTicketListing"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"SupervisorTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"CountryManagerTicketListing",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"SupervisorTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"CountryManagerTicketListing"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																CM Tickets
															</Link>{" "}
														</MenuItem>
													</>
												)}
											</SubMenu>
										) : (
											<></>
										)}
										{/*---------End of Supervisor Tasks ------------*/}

										{/*Supervisors tasks for Administrator */}
										{userDetails.designation.toString() ===
											"7" ||
										userDetails.empRole.includes("4") ? (
											<SubMenu
												title="Supervisor Tasks"
												icon={
													<span className="tossIcon tossIcon-calendar" />
												}
												defaultOpen={
													sessionStorage.getItem(
														"NavbarTab"
													) === "SupervisorTasks"
												}
											>
												<>
													<MenuItem
														className="proMenuItemInner"
														icon={
															<span className="tossIcon tossIcon-clock"></span>
														}
														style={
															props.navbarItem ===
															"spOffsiteWorkHours"
																? selectedMenuItemStyle
																: null
														}
													>
														<Link
															to="/spOffsiteWorkHours"
															onClick={() => {
																dispatch({
																	type: SET_NAVBAR_TAB,
																	payload:
																		"SupervisorTasks",
																});
																dispatch({
																	type: SET_NAVBAR_ITEMS,
																	payload:
																		"spOffsiteWorkHours",
																});
																sessionStorage.removeItem(
																	"TopBarTab"
																);
																sessionStorage.removeItem(
																	"TopBarItem"
																);
																sessionStorage.setItem(
																	"NavbarTab",
																	"SupervisorTasks"
																);
																sessionStorage.setItem(
																	"NavbarItem",
																	"spOffsiteWorkHours"
																);
																props.handleToggleSidebar(
																	false
																);
															}}
														>
															Offsite Work
															Requests
														</Link>
													</MenuItem>
												</>
											</SubMenu>
										) : (
											<></>
										)}

										{/*--------- Admin Tasks ------------*/}
										{userDetails.empRole.includes("3") ? (
											<>
												<SubMenu
													title="Admin Tasks"
													className="submenu"
													icon={
														<span className="tossIcon tossIcon-calendar" />
													}
													defaultOpen={
														sessionStorage.getItem(
															"NavbarTab"
														) === "AdminTasks"
													}
													style={
														props.navbarTab ===
														"AdminTasks"
															? tabActiveStyle
															: tabStyle
													}
												>
													<>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-log" />
															}
															style={
																props.navbarItem ===
																"adminRole/CompensationLog"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/CompensationLog"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/CompensationLog",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.removeItem(
																		"AdminCompensationLog"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/CompensationLog"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Compensation Log
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-extract" />
															}
															style={
																props.navbarItem ===
																"adminRole/ExportAttendance"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/ExportAttendance"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/ExportAttendance",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/ExportAttendance"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Export
																Attendance
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-team" />
															}
															style={
																props.navbarItem ===
																"adminRole/EmployeeWorkStatus"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/EmployeeWorkStatus"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/EmployeeWorkStatus",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/EmployeeWorkStatus"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Employee Work
																Status
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-clock" />
															}
															style={
																props.navbarItem ===
																"adminRole/UpdateAttendance"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/UpdateAttendance"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/UpdateAttendance",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/UpdateAttendance"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Employee
																Attendance
																Update
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-clock" />
															}
															style={
																props.navbarItem ===
																"adminRole/AddEmployee"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/AddEmployee"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/AddEmployee",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/AddEmployee"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Add Employee
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-clock" />
															}
															style={
																props.navbarItem ===
																"adminRole/ViewLeaves"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/ViewLeaves"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/ViewLeaves",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/ViewLeaves"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																View Leaves
																Applications
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="fas fa-users usersIcon"></span>
															}
															style={
																props.navbarItem ===
																"ViewEmployees"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/ViewEmployees"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ViewEmployees",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.removeItem(
																		"ViewEmployees"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ViewEmployees"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																View Employees
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="fas fa-users usersIcon" />
															}
															style={
																props.navbarItem ===
																"adminRole/ManageDesignation"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/ManageDesignation"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"ManageDesignation",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/ManageDesignation",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"ManageDesignation"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/ManageDesignation"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Add Designation
															</Link>
														</MenuItem>
													</>
												</SubMenu>
												{/*--------- End of Admin Tasks ------------*/}

												{/*--------- Settings ------------*/}

												<SubMenu
													title="Settings"
													className="submenu"
													icon={
														<span className="tossIcon tossIcon-calendar" />
													}
													defaultOpen={
														sessionStorage.getItem(
															"NavbarTab"
														) === "Settings"
													}
													style={
														props.navbarTab ===
														"Settings"
															? tabActiveStyle
															: tabStyle
													}
												>
													<>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-clock" />
															}
															style={
																props.navbarItem ===
																"MonthlyTimesheetsConfig"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/MonthlyTimesheetsConfig"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"Settings",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"MonthlyTimesheetsConfig",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"Settings"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"MonthlyTimesheetsConfig"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Monthly
																Timesheets
																Config
															</Link>
														</MenuItem>
														<MenuItem
															className="proMenuItemInner"
															icon={<FaUserCog />}
															style={
																props.navbarItem ===
																"Settings/lateNotifications"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/Settings/lateNotifications"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"Settings",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"Settings/lateNotifications",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"Settings"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"Settings/lateNotifications"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Late
																Notifications
															</Link>
														</MenuItem>

														<MenuItem
															className="proMenuItemInner"
															icon={
																<i
																	className="fa fa-calendar"
																	style={{
																		fontWeight:
																			"100",
																	}}
																></i>
															}
															style={
																props.navbarItem ===
																"AdminCalendarHolidays"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/AdminCalendarHolidays"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"Settings",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"AdminCalendarHolidays",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"Settings"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"AdminCalendarHolidays"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Calendar
																Holidays
															</Link>
														</MenuItem>
													</>
												</SubMenu>
												{/*--------- End of Settings  ------------*/}
											</>
										) : (
											<></>
										)}
										{/*--------- Accounts ------------*/}
										{userDetails.empRole.includes("5") ? (
											<>
												<SubMenu
													title="Admin Tasks"
													icon={
														<span className="tossIcon tossIcon-calendar" />
													}
													className="submenu"
													defaultOpen={
														sessionStorage.getItem(
															"NavbarTab"
														) === "AdminTasks"
													}
													style={
														props.navbarTab ===
														"AdminTasks"
															? tabActiveStyle
															: tabStyle
													}
												>
													<>
														<MenuItem
															className="proMenuItemInner"
															icon={
																<span className="tossIcon tossIcon-extract" />
															}
															style={
																props.navbarItem ===
																"adminRole/ExportAttendance"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to="/adminRole/ExportAttendance"
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"AdminTasks",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"adminRole/ExportAttendance",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"AdminTasks"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"adminRole/ExportAttendance"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Export
																Attendance
															</Link>
														</MenuItem>
													</>
												</SubMenu>
												<SubMenu
													title="Settings"
													icon={
														<span className="tossIcon tossIcon-calendar" />
													}
													className="submenu"
													defaultOpen={
														sessionStorage.getItem(
															"NavbarTab"
														) === "Settings"
													}
													style={
														props.navbarTab ===
														"Settings"
															? tabActiveStyle
															: tabStyle
													}
												>
													<>
														<MenuItem
															className="proMenuItemInner"
															icon={<FaUserCog />}
															style={
																props.navbarItem ===
																"ReimbursementPolicy"
																	? selectedMenuItemStyle
																	: null
															}
														>
															<Link
																to={
																	"/ReimbursementPolicy"
																}
																onClick={() => {
																	dispatch({
																		type: SET_NAVBAR_TAB,
																		payload:
																			"Settings",
																	});
																	dispatch({
																		type: SET_NAVBAR_ITEMS,
																		payload:
																			"ReimbursementPolicy",
																	});
																	sessionStorage.removeItem(
																		"TopBarTab"
																	);
																	sessionStorage.removeItem(
																		"TopBarItem"
																	);
																	sessionStorage.setItem(
																		"NavbarTab",
																		"Settings"
																	);
																	sessionStorage.setItem(
																		"NavbarItem",
																		"ReimbursementPolicy"
																	);
																	props.handleToggleSidebar(
																		false
																	);
																}}
															>
																Reimbursements
																Policy
															</Link>
														</MenuItem>

														<OverlayTrigger
  key="tooltip"
  placement="right"
  overlay={<Tooltip id={`tooltip-right`}> Upload Reimbursements Policy</Tooltip>}
>
  <MenuItem
    className="proMenuItemInner"
    icon={<FaUserCog />}
    style={props.navbarItem === "ReimbursementPolicy" ? selectedMenuItemStyle : null}
  >
    <Link
      to={"/ReimbursementPolicyUpload"}
      onClick={() => {
        dispatch({ type: SET_NAVBAR_TAB, payload: "Settings" });
        dispatch({ type: SET_NAVBAR_ITEMS, payload: "FuelReimbursementPolicy" });
        sessionStorage.removeItem("TopBarTab");
        sessionStorage.removeItem("TopBarItem");
        sessionStorage.setItem("NavbarTab", "Settings");
        sessionStorage.setItem("NavbarItem", "FuelRReimbursementPolicy");
        props.handleToggleSidebar(false);
      }}
    >
      Upload Reimbursements Policy
    </Link>
  </MenuItem>
</OverlayTrigger>
													</>
												</SubMenu>
											</>
										) : (
											<></>
										)}
									</Menu>
								</SidebarContent>
								<div className="sideBarEnd">
									<div className="mobileAppsContainer">
										<img
											style={{
												height: "45px",
												width: "45px",
												cursor: "pointer",
											}}
											src={AndroidLogo}
											alt="android"
											onClick={() => {
												setIsAndoidQr(true);
												setmodalShow(true);
											}}
										/>
										<img
											style={{
												height: "45px",
												width: "45px",
												marginLeft: "15px",
												cursor: "pointer",
											}}
											src={IOSLogo}
											alt="IOS"
											onClick={() => {
												setIsIOSQr(true);
												setmodalShow(true);
											}}
										/>
									</div>
									<p className="mobileAppsText">
										Download TOSS app
									</p>
								</div>
							</ProSidebar>
						</aside>
						<Modal
							size="md"
							aria-labelledby="contained-modal-title-vcenter"
							centered
							show={modalShow}
							className="imp-info-PopUp p-2"
						>
							<Modal.Header>
								<Modal.Title
									id="contained-modal-title-vcenter"
									className="QRTitle px-3"
								>
									{isAndroidQr &&
										"Scan to download our android App"}
									{isIOSQr && "Scan to download our iOS App"}
								</Modal.Title>
								<CloseButton
									style={{ marginTop: "2px" }}
									onClick={() => {
										setIsIOSQr(false);
										setIsAndoidQr(false);
										setmodalShow(false);
									}}
								/>
							</Modal.Header>
							<Modal.Body className="mb-1 p-0">
								{isAndroidQr && (
									<div className="px-5">
										<div className="d-flex align-items-center justify-content-center">
											<div className="QR">
												<img
													src={android}
													alt="awSnap"
												/>
											</div>
										</div>
									</div>
								)}
								{isIOSQr && (
									<div className="px-5">
										<div className="QRNote">Note :</div>
										<p className="QRText">
											Please use Chrome browser (not
											safari) to access TOSS app URL You
											have to Trust the profile available
											under{" "}
											<b>
												Settings <span>&#62;</span>
												General <span>&#62;</span>{" "}
												Profiles & Device Management and
												then Trust the TOSS Enterprise
												App.
											</b>
										</p>
										<div className="d-flex align-items-center justify-content-center">
											<div className="qrBody">
												<div className="QR">
													<img
														src={ios}
														alt="awSnap"
													/>
												</div>
											</div>
										</div>
									</div>
								)}
							</Modal.Body>
						</Modal>
					</>
				);
			}}
		</UserConsumer>
	);
};

const mapStateToProps = (state) => ({
	navbarTab: state.navbarTab,
	navbarItem: state.navbarItem,
});
export default connect(mapStateToProps)(Aside);
